import React from 'react'

export default function InfoIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="12" viewBox="0 0 11 12" fill="none">
            <path d="M5.5 0.666504C2.46231 0.666504 0 3.12881 0 6.1665C0 9.2042 2.46231 11.6665 5.5 11.6665C8.53769 11.6665 11 9.2042 11 6.1665C11 3.12881 8.53769 0.666504 5.5 0.666504ZM5.5 9.2867C5.14927 9.2867 4.86538 9.00239 4.86538 8.65208C4.86538 8.30177 5.14927 8.01747 5.5 8.01747C5.85031 8.01747 6.13462 8.30177 6.13462 8.65208C6.13462 9.00239 5.85031 9.2867 5.5 9.2867ZM6.13462 6.5367C6.13462 6.887 5.85031 7.17131 5.5 7.17131C5.14927 7.17131 4.86538 6.887 4.86538 6.5367V3.57516C4.86538 3.22443 5.14927 2.94054 5.5 2.94054C5.85031 2.94054 6.13462 3.22443 6.13462 3.57516V6.5367Z" fill="#E4E4E4" stroke="#E4E4E4" strokeWidth="0.000213333" />
        </svg>
    )
}
